export const LAYOUT = {
  MAIN_HEADER: "MAIN_HEADER",
  HEADER: "HEADER",
  SIDEBAR: "SIDEBAR"
};
